import { renderPrintDocument } from "../../core/renderPrintDocument";
import { escapeHtml } from "../../shared/escapeHtml";
import { officialDocumentStyles } from "../../shared/officialDocumentStyles";
import { createVefPrintViewModelV2 } from "./createVefPrintViewModelV2";

const vefStylesV2 = `
  ${officialDocumentStyles}

  .vef-title-only {
    margin: 0 0 2mm;
    font-size: 18pt;
    font-weight: 700;
    line-height: 1.15;
  }

  .vef-summary-table td,
  .vef-summary-table th,
  .vef-log-table td,
  .vef-log-table th {
    text-align: center;
  }

  .vef-log-table td:nth-child(3),
  .vef-log-table td:nth-child(4) {
    text-align: left;
  }
`;

const formatNumber = (value, decimals = 2) => Number(value || 0).toFixed(decimals);

const renderVefBody = (model, t) => `
  <main class="official-document">
    <header class="official-section">
      <h1 class="vef-title-only">${escapeHtml(model.title)}</h1>
      <p class="official-note">Generated on ${escapeHtml(model.generatedAt)}</p>
    </header>

    <hr class="official-rule" />

    <section class="official-section">
      <h2 class="official-title">${escapeHtml(t("summaryof20"))}</h2>
      <table class="official-table vef-summary-table">
        <thead>
          <tr>
            <th>${escapeHtml(t("totalShip"))}</th>
            <th>${escapeHtml(t("totalShore"))}</th>
            <th>${escapeHtml(t("overallshipshore"))}</th>
            <th>${escapeHtml(t("totalShipQualified"))}</th>
            <th>${escapeHtml(t("totalShoreQualified"))}</th>
            <th>${escapeHtml(t("vesselExperienceFactor"))}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>${escapeHtml(formatNumber(model.totals.totalShipAll))}</td>
            <td>${escapeHtml(formatNumber(model.totals.totalShoreAll))}</td>
            <td>${escapeHtml(formatNumber(model.totals.overallRatio, 4))}</td>
            <td>${escapeHtml(formatNumber(model.totals.totalShipQualified))}</td>
            <td>${escapeHtml(formatNumber(model.totals.totalShoreQualified))}</td>
            <td>${escapeHtml(formatNumber(model.totals.vef, 4))}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="official-section">
      <h2 class="official-title">Latest 20 Voyages</h2>
      <table class="official-table vef-log-table">
        <thead>
          <tr>
            <th>${escapeHtml(t("table.sequence"))}</th>
            <th>${escapeHtml(t("table.date"))}</th>
            <th>${escapeHtml(t("table.cargo"))}</th>
            <th>${escapeHtml(t("table.port"))}</th>
            <th>${escapeHtml(t("table.shipLoaded"))}</th>
            <th>${escapeHtml(t("table.shoreBL"))}</th>
            <th>${escapeHtml(t("table.ratio"))}</th>
            <th>${escapeHtml(t("table.qualified"))}</th>
          </tr>
        </thead>
        <tbody>
          ${model.voyages
            .map(
              (voyage, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${escapeHtml(voyage.date || "\u2014")}</td>
                  <td>${escapeHtml(voyage.cargo || "\u2014")}</td>
                  <td>${escapeHtml(voyage.port || "\u2014")}</td>
                  <td>${escapeHtml(formatNumber(voyage.shipLoaded))}</td>
                  <td>${escapeHtml(formatNumber(voyage.shoreBL))}</td>
                  <td>${escapeHtml(String(voyage.ratio || "\u2014"))}</td>
                  <td>${voyage.qualifying ? "Yes" : "No"}</td>
                </tr>
              `
            )
            .join("")}
        </tbody>
      </table>
    </section>
  </main>
`;

export const renderVefV2 = (input) => {
  const model = createVefPrintViewModelV2(input);

  return renderPrintDocument({
    title: model.title,
    templateId: "vef",
    viewModel: model,
    styles: vefStylesV2,
    body: renderVefBody(model, input.t),
  });
};
